module.exports = __webpack_public_path__ + "img/29.1eb91cb2.jpg";